import $ from 'jquery';

class AjaxForm {
    constructor() {
    // constructor(form) {
    //     this.form = form;

        this.valid = false;
        this.form = null;
        this.responseErrors = null;
        this.response = null;
        this.success = false;

        // this.form.find("input[type='checkbox']").on('change', function() {
        //     if(this.checked) {
        //         $('.checkbox-error').addClass('hidden');
        //     }
        // });
    }

    init (form) {
        this.form = form;
        this.form.find("input[type='checkbox']").on('change', function() {
            if(this.checked) {
                $('.checkbox-error').addClass('hidden');
            }
        });
    }

    validate () {
        var citizenType = this.form.find('input[name=registration_citizen_type]');
        var isCitizenTypeSelected = this.form.find('#citizen-not-selected');
        if (!citizenType.is(':checked') && isCitizenTypeSelected.length !== 0) {
            citizenType.parent().addClass('invalid');
            isCitizenTypeSelected.css('color', 'red').show();
            return;
        }

        $('.cinput.invalid:not(.optional),.checkbox_cont:not(.checked):not(.optional),.cselect.default:not(.optional)', this.form).addClass('wrong');
        $('.cinput.invalid:not(.optional),.checkbox_cont:not(.checked):not(.optional),.cselect.default:not(.optional)', this.form).parents('.input-wrapper').find('.error_msg').removeClass('hidden').show();
        $('.cinput.wrong.optional,.checkbox_cont.optional:not(.checked),.cselect.wrong.optional', this.form).removeClass('wrong');
        $('.code_step3 .cinput').removeClass('wrong');

        $('.must-be-same-as').each(function() {
            var input = $(this);
            var value = input.val();
            var duplicateInput = $(input.attr('data-target'));
            if (value !== duplicateInput.val()) {
                input.parents('.cinput').addClass('wrong');
                input.parents('.input-wrapper').find('.error_msg').not('.length-error').removeClass('hidden').show();
            }
        });

        $('.length-validation').each(function () {
            var min = $(this).data('min-length');
            var max = $(this).data('max-length');

            var $input = $(this).find('input');
            if (typeof $input == 'undefined') {
                return;
            }

            var inputValue = $input.val();

            if ($(this).hasClass('optional') && inputValue == '') {
                //is optional and not filled
                return;
            }

            var fail = false;

            if (typeof min != 'undefined' && inputValue.length < min) {
                fail = true;
            }

            if (typeof max != 'undefined' && inputValue.length > max) {
                fail = true;
            }

            if (fail == true) {
                $(this).addClass('wrong').addClass('invalid');
                $(this).parent('.input-wrapper').find('.length-error').removeClass('hidden').show();
            }
        });

        var wrongs=$('.cinput.wrong,.checkbox-line.wrong, .cselect.wrong, .input-wrapper.wrong, .checkbox-line.wrong', this.form);
        if (wrongs.length) {
            var c_el=wrongs.first();
            if(c_el.closest('.field').length)c_el=c_el.closest('.field');
            $('html,body').stop(true).animate({'scrollTop':c_el.offset().top+'px'},400);

            if ($("input:checkbox:not(:checked)").length > 0) {
                $('.checkbox-error').removeClass('hidden');
            }

            this.valid = false;
        } else {
            this.valid = true;
        }
    }

    isValid () {
        return this.valid;
    }

    isSuccess () {
        return this.success;
    }

    submit (callback) {
        let that = this;
        this.resetErrors();

        var url = this.form.attr('action');

        // Find disabled inputs, and remove the "disabled" attribute
        var disabled = this.form.find(':input:disabled').removeAttr('disabled');

        // serialize the form
        var serialized = this.form.serialize();

        // re-disabled the set of inputs that you previously enabled
        disabled.attr('disabled','disabled');

        $.post(url, serialized, function (response) {
            if (typeof response.errors != 'undefined') {

                that.responseErrors = response.errors;
                that.response = response;
                that.showResponseErrors();

                var firstError = that.form.find('.wrong').first();

                if (firstError.length > 0) {
                    $('html,body').stop(true).animate({'scrollTop':firstError.offset().top+'px'},400);
                }

                that.success = false;
            } else {
                that.success = true;
            }

            if (typeof callback == 'function') {
                callback();
            }
        });
    }

    showResponseErrors () {
        this.parseErrorFields(this.responseErrors);
    }

    parseErrorFields (array, parentField) {
        let that = this;
        $.each(array, function (field, additionalInfo) {


            if (field == 'adrId') {
                //common address error

                if (typeof additionalInfo == 'object') {
                    additionalInfo = $('.common-address-error').data('default');
                }

                var $commonErrorWrapper = $('.common-address-error');
                $commonErrorWrapper.text(additionalInfo)
                    .removeClass('hidden')
                    .addClass('wrong');
            } else if (field == 'common') {
                //some unknown error
                var $commonErrorWrapper = $('.application-service-error');
                $commonErrorWrapper.text(additionalInfo)
                    .removeClass('hidden')
                    .addClass('wrong');
            } else {
                //simple field error
                if (typeof parentField != 'undefined') {
                    field = parentField + "[" + field + "]";
                }

                var nameString = '[name="' + field + '"]';

                var inputField = $(nameString);

                if (inputField.length > 0) {
                    //if input is simple by name, i.e. name="client"
                    var errorMsg = '';

                    if (typeof additionalInfo == 'object') {
                        errorMsg = additionalInfo[Object.keys(additionalInfo)[0]];
                    }
                    if (typeof additionalInfo == 'string') {
                        errorMsg = additionalInfo;
                    }
                    that.showError(inputField, errorMsg);
                } else {
                    //if input is nested by name, i.e. name="client[somStuff]"
                    if (typeof additionalInfo == 'array' || typeof additionalInfo == 'object') {
                        that.parseErrorFields(additionalInfo, field);
                    }
                }
            }
        });
    }

    static inputClick (input) {
        input.next('.msg').remove();
        input.removeClass('wrong');
    }

    showError (errorField, errorMsg) {

        if (typeof errorMsg == 'object') {
            errorMsg = errorMsg[Object.keys(errorMsg)[0]];
        }

        var parentInput = errorField.parent('.cinput, .cselect .textouter, .checkbox-line');

        var errorHtml = '<div class="msg">';
        errorHtml = errorHtml + '<div class="sp6"></div>';
        errorHtml = errorHtml + '<div class="fs1420 color-red">';
        errorHtml = errorHtml + errorMsg;
        errorHtml = errorHtml + '</div>';
        errorHtml = errorHtml + '<div class="mt-8"></div>';
        errorHtml = errorHtml + '</div>';

        if (parentInput.length > 0) {
            parentInput.next('.msg').remove();
            parentInput.addClass('wrong');
            parentInput.after(errorHtml);
        }

        var parentSelect = errorField.parent('.cselect');

        var wrapper = errorField.parent('div');

        if (parentSelect.length > 0) {
            parentSelect.next('.msg').remove();
            parentSelect.addClass('wrong');
            parentSelect.after(errorHtml);
        }

        if (parentInput.length == 0 && parentSelect.length == 0) {

            var declarationInput = wrapper.find('.code_step2 .fs2024');
            var declarationInput2 = wrapper.find('.code_step3 .fs2024');

            if(declarationInput.length > 0) {

                $('.linked_part', wrapper).each(function(){
                    $(this).val('').data('prevval', 0);
                    $(this).parent('.cinput').addClass('wrong');

                });

                errorField.addClass('wrong').removeClass('hidden');

                declarationInput.next('.msg').remove();
                declarationInput.after(errorHtml);

                declarationInput2.next('.msg').remove();
                declarationInput2.after(errorHtml);
            }
            else {

                wrapper.next('.msg').remove();
                wrapper.addClass('wrong').removeClass('hidden');
                wrapper.after(errorHtml);
            }

        }
    }

    resetErrors () {
        this.form.find('.error_msg').addClass('hidden').text('');
        this.form.find('.wrong').parent().find('.msg').remove();
        this.form.find('.wrong').removeClass('wrong');
    }
}

export default AjaxForm;